import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import { Wrapper } from "./Components/Wrapper";
import Header from "./Layouts/Header";
import Home from "./pages/Home";
import Building from "./pages/Buliding";
import Footer from "./Layouts/Footer";
import "./index.css";
import Availability from "./pages/Availability";
import Availability2 from "./pages/Availability2";
import Neighborhood from "./pages/Neighborhood";
import ImgBlog from "./pages/ImgBlog";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import Gallery from "./pages/Gallery";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import { logout } from "./store/actions/authActions";
import UpdateGallery from "./pages/UpdateGallery";
//import Test from "./pages/Test";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";

// Initialize GA4 with your measurement ID
ReactGA.initialize("G-SC2LZNFB3L");

// Create a component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);

  return null;
}

function App() {
  const [showAdminBoard, setShowAdminBoard] = useState(false);

  const currentUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (currentUser) {
      setShowAdminBoard(currentUser[0].isAdmin);
    } else {
      setShowAdminBoard(false);
    }
  }, [currentUser]);
  // const dispatch = useDispatch();

  // const logOut = useCallback(() => {
  //   dispatch(logout());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (currentUser) {
  //     setShowAdminBoard(currentUser.isAdmin);
  //   } else {
  //     setShowAdminBoard(false);
  //   }

  //   EventBus.on("logout", () => {
  //     logOut();
  //   });

  //   return () => {
  //     EventBus.remove("logout");
  //   };
  // }, [currentUser, logOut]);
  return (
    <>
      <Helmet>
        <title>Union Center | Luxury Office Space in Flushing, NY</title>
        <meta
          name="description"
          content="Union Center offers state-of-the-art office spaces in the heart of Flushing, NY. Experience luxury, sustainability, and prime location in our 133,000 sq ft commercial building."
        />
        <meta
          name="keywords"
          content="Union Center, Flushing office space, luxury commercial building, sustainable office building, NYC commercial real estate"
        />
        <link rel="canonical" href="https://www.3716union.com" />
      </Helmet>
      <BrowserRouter>
        <PageTracker />
        <Wrapper>
          <div className="flex flex-col App bg-custom-color">
            <Header />
            <Routes>
              <Route path="/" exact element={<Home />}></Route>
              {/* <Route path="/test" exact element={<Test />}></Route> */}
              <Route path="/building" exact element={<Building />}></Route>
              <Route
                path="/availability"
                exact
                element={<Availability />}
              ></Route>
              <Route
                path="/availability2"
                exact
                element={<Availability2 />}
              ></Route>
              <Route
                path="/neighborhood/"
                exact
                element={<Neighborhood />}
              ></Route>
              <Route
                path="/neighborhood/:slug"
                exact
                element={<ImgBlog />}
              ></Route>
              <Route path="/contact" exact element={<Contact />}></Route>
              <Route path="/gallery" exact element={<Gallery />}></Route>
              <Route path="/team" exact element={<Team />}></Route>
              <Route path="/register" exact element={<Register />}></Route>
              <Route path="/login" exact element={<Login />}></Route>
              <Route path="/admin" exact element={<Admin />}></Route>
              <Route
                path="/update-gallery"
                exact
                element={<UpdateGallery />}
              ></Route>
            </Routes>
            <Footer />
            {/* <ReactScrollToTop
            smooth
            className="scroll-to-top-button border-brown-bg bg-main-bg animate-duration hover:bg-brown-bg rounded-full border-[2px]"
            height="22"
          /> */}
          </div>
        </Wrapper>
      </BrowserRouter>
    </>
  );
}

export default App;
